import { render, staticRenderFns } from "./homePage.vue?vue&type=template&id=3b4ec65a"
import script from "./homePage.vue?vue&type=script&lang=ts"
export * from "./homePage.vue?vue&type=script&lang=ts"
import style0 from "./homePage.vue?vue&type=style&index=0&id=3b4ec65a&prod&lang=less"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports